import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Login from "@components/pages/loginPage/components/Login";
import Tenant from "@components/pages/loginPage/components/Tenant";
import { useIsAuthenticated, useMsal } from "@auth";
import Main from "@components/primitives/main/Main";
import LoginBg from "@images/login.jpg";
import HublLogo from "@logos/hubl.svg?react";
import useLogout from "@hooks/useLogout";
import usePageTitle from "@hooks/usePageTitle";
import useQueryTenant from "@components/pages/loginPage/hooks/useQueryTenant";

const LoginPage: FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const { t } = useTranslation();
  const logout = useLogout();
  const { accounts } = useMsal();
  const currentAccount = accounts.length ? accounts[0] : null;
  const { createPageTitle } = usePageTitle();

  useQueryTenant();

  return (
    <>
      <title>
        {createPageTitle(t("login.title", { ns: "authentication" }))}
      </title>
      <meta name="description" content={t("meta.description")} />
      <Main hasCover>
        {/* eslint-disable-next-line max-len*/}
        <section className="loginBox">
          <div
            className="loginBox__image"
            style={{
              backgroundImage: `url(${LoginBg})`,
            }}
          />
          <div className="loginBox__content">
            <HublLogo className="loginBox__logo" />
            <div>{!isAuthenticated ? <Login /> : <Tenant />}</div>
          </div>
        </section>
        <div className="loginBox__footer">
          {isAuthenticated && currentAccount ? (
            <p data-testid="login-text-logged-in">
              {t("login.textLoggedIn", {
                ns: "authentication",
                username: currentAccount.username,
              })}
              &nbsp;-&nbsp;
              <span onClick={logout}>
                {t("logout", { ns: "authentication" })}
              </span>
            </p>
          ) : null}
        </div>
      </Main>
    </>
  );
};

export default LoginPage;
